import { getOWAConnectedAccounts, isMonarchMultipleAccountsEnabled } from 'owa-accounts-store';
import getPrimaryAccount from './getPrimaryAccount';

export default function getAllAccounts(): string[] {
    if (isMonarchMultipleAccountsEnabled()) {
        // When running against the new account store, the primary account is included
        // in the connected accounts map. Cleaning up this confusion will be tracked by VSO# 127698.
        return [...getOWAConnectedAccounts().map(account => account.userIdentity)];
    }
    return [getPrimaryAccount(), ...getOWAConnectedAccounts().map(account => account.userIdentity)];
}
